export default "https://cdn-static.gokick.com/assets/b944ecdade3ab4b24738bd1fcec1eea00d00fb75/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";